import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getNotificationsFromApi, getNotificationsTotalCountFromApi } from '../redux/actions/notifications';

const NOTIFICATIONS_POLLING_INTERVAL = 5 * 60 * 1000;

export const useDispatchNotificationsOnMount = () => {
  const dispatch = useDispatch();

  const dispatchNotifications = useCallback(() => {
    dispatch(getNotificationsFromApi());
    dispatch(getNotificationsTotalCountFromApi());
  }, [dispatch]);

  useEffect(() => {
    dispatchNotifications();

    const intervalId = window.setInterval(dispatchNotifications, NOTIFICATIONS_POLLING_INTERVAL);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [dispatchNotifications]);
};
